<template>
  <v-form ref="form" v-model="validForm">
    <v-row align="center" class=" px-1">
      <v-col>
        <v-card v-if="eventTax" class="mb-2">
          <v-card-title>
            <div>{{ $t('eventTaxes') }}</div><v-spacer></v-spacer>
            <div class="title text-align-center">
              {{ eventParticipationTaxAmount }} {{ $t(currency) }}
            </div>
          </v-card-title>
          <v-card-text>
            <v-overlay
              :value="taxPayed || taxPending"
              :absolute=true
              class="align-center justify-center"
              disabled=true
              persistent=true
            >
            <div>
              {{ taxPayed ? $t('taxPayed') : $t('taxPayedPending') }}
            </div>
            </v-overlay>
            <v-select v-if="filteredParticipationType && filteredParticipationType.length > 1"
              :items="filteredParticipationType"
              :label="$t('taxParticipationType')"
              :value="participant.services.participationType"
              :item-text="translateOption"
              item-value="id"
              :rules="[required]"
              @change="handleParticipationTypeChange"
            ></v-select>
            <v-row v-if="eventParticipationTax">
              <v-col cols="12">
                <div>
                  {{ $t("taxDescription") }}
                  {{ $t(evenName) }}
                  - {{ eventParticipationTaxAmount }} {{ $t(currency) }} -
                  {{ $t("taxUntil") }}
                  {{ eventTax.endDate }}
                </div>
                <div v-if="eventTax.description" class="sub-title">
                  {{ $t(eventTax.description) }}
                </div>
                <div v-if="eventNote" class="sub-title">
                  {{ $t(eventNote) }}
                </div>
              </v-col>
              <v-col cols="12">
                <v-checkbox class="px-2" :label="$t('taxSponsored')" v-model="participant.services.sponsored">
                </v-checkbox>
              </v-col>
              <v-col cols="12" v-if="participant.services.sponsored">
                <v-text-field v-bind:label="$t('taxSponsor')" v-model="participant.services.sponsoredBy"
                  :rules="[required]"></v-text-field>
              </v-col>
              <v-col cols="12" v-if="participant.services.sponsored">
                <v-text-field v-bind:label="$t('taxSponsorNotes')" v-model="participant.services.sponsoredDetails"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="requiredServices && requiredServices.length > 0" align="center" class=" px-1">
      <v-col>
        <v-card>
          <v-card-title>
            <div>{{ $t("taxMandatoryServices") }}</div><v-spacer></v-spacer>
            <div>
              {{ requiredServicesPrice }}
              {{ $t(currency) }}
            </div>
          </v-card-title>
          <v-card-text class="d-flex">
            <v-row>
            <v-col cols="12" sm="4" v-for="service in requiredServices" :key="service.id">
              <v-card class="elevation-0" outlined>
                <v-card-title class="word-break">{{ $t(service.name) }}</v-card-title>
                <v-card-text>
                  <v-overlay
                  :value="servicePayed(service.id)"
                    :absolute=true
                    class="align-center justify-center"
                    disabled=true
                    persistent=true
                  >
                    <div>
                      {{ servicePayAccepted(service.id) ? $t('payed') :   $t('payedPending') }}
                    </div>
                  </v-overlay>
                  <div class="text-subtitle-1">
                    {{ servicePrice(service) }} {{ $t(currency) }}
                  </div>

                  <div>{{ $t(service.description) }}</div>
                </v-card-text>
              </v-card>
            </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="optionalServices && optionalServices.length > 0" align="center" class=" px-1">
      <v-col>
        <v-card>
          <v-card-title>
            <div>{{ $t("taxOptionalServices") }}</div><v-spacer></v-spacer>
            <div class="title text-align-center">
              {{ optionalServicesPrice }}
              {{ $t(currency) }}
            </div>
          </v-card-title>
          <v-card-text class="d-flex">
            <v-row>
              <v-col cols="12" sm="4" v-for="service in optionalServices" :key="service.id">
                <v-row>
                  <v-col cols="12">
                    <v-card class="elevation-0" outlined :class="{'selected-item-container' : isServiceSelected(service.id)}">
                      <p class="selected-item-text">{{ $t('serviceSelected') }}</p>
                      <v-card-title class="word-break">{{ $t(service.name) }}</v-card-title>
                      <v-card-text>
                        <v-overlay
                          v-if="!servicePayed(service.id) && !isServiceSelected(service.id) && (service.reservedPlaces && service.reservedPlaces>=service.totalPlaces)"
                          :absolute=true
                          class="align-center justify-center"
                          disabled=true
                          persistent=true
                        >
                          <div>
                            {{ $t('serviceNoMorePlaces') }}
                          </div>
                        </v-overlay>
                        <v-overlay
                        :value="servicePayed(service.id)"
                          :absolute=true
                          class="align-center justify-center"
                          disabled=true
                          persistent=true
                        >
                          <div>
                            {{ servicePayAccepted(service.id) ? $t('payed') :   $t('payedPending') }}
                          </div>
                        </v-overlay>
                        <v-overlay
                        :value="!servicePayed(service.id) && hasServiceIntervalIntersectionMessage(service) && !(service.reservedPlaces && service.reservedPlaces>=service.totalPlaces)"
                          :absolute=true
                          class="align-center justify-center"
                          disabled=true
                          persistent=true
                        >
                          <div>
                            {{ hasServiceIntervalIntersectionMessage(service)}}
                          </div>
                        </v-overlay>
                        <div class="text-subtitle-1">
                          {{ servicePrice(service) }} {{ $t(currency) }}
                        </div>  
                        <div v-if="service.startDate && service.endDate">
                          {{ new Date(service.startDate).toLocaleString($i18n.locale) }} 
                          - 
                          {{ new Date(service.endDate).toLocaleString($i18n.locale) }} 
                        </div>
                        <div>{{ $t(service.description) }}</div>
                        
                      </v-card-text>
                      <v-card-actions>
                        <v-btn color="primary" @click="serviceSelected(service.id)">
                          <span v-if="!isServiceSelected(service.id)">
                            {{ $t("taxSelect") }}
                          </span>
                          <span v-if="isServiceSelected(service.id)">
                            {{ $t("taxUnselect") }}
                          </span>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row v-if="getParticipantSelectedService(service.id)">
                  <v-col cols="12">
                    <v-checkbox class="px-2" :label="$t('serviceSponsored')" v-model="getParticipantSelectedService(service.id).sponsored"
                    @click="serviceSponsoredClick(service)">
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" v-if="getParticipantSelectedService(service.id).sponsored">
                    <v-text-field v-bind:label="$t('serviceSponsoredBy')" v-model="getParticipantSelectedService(service.id).sponsoredBy"
                      :rules="[required]"></v-text-field>
                  </v-col>
                  <v-col cols="12" v-if="getParticipantSelectedService(service.id).sponsored">
                    <v-text-field v-bind:label="$t('serviceSponsoredDetails')" v-model="getParticipantSelectedService(service.id).sponsoredDetails"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row align="center" class=" px-1">
      <v-col class="text-align-center">
        <div class="title text-align-center">
          {{ $t("taxTotal") }} {{ totalPriceServices }}
          {{ $t(currency) }}
        </div>
      </v-col>
    </v-row>
  </v-form>
</template>
  
<script>
import { participant } from "@/model/participant";
import { isTaxPayed,isServicePayed, getTaxPayment } from "@/utils/utils.js";
import { getServicePayment, isPaymentPending, matchParticipantCondition } from '../utils/utils';
import Vue from 'vue';
export default {
  emits: ["formValid"],
  props: {
    evenName: {
      type: String,
      required: true,
    },
    eventTax: {
      type: Object,
      required: true,
    },
    eventNote: {
      type: String,
      required: true,
    },
    participationTypes: {
      type: Array,
      required: true,
    },
    requiredServices: {
      type: Array,
      required: true,
    },
    optionalServices: {
      type: Array,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      validForm: false,
      participant,
      eventParticipationTaxTrigger : 0
    };
  },
  watch: {
    validForm(newVal) {
      this.$emit("formValid", newVal);
    },
    'participant.services.sponsored' : function(newVal){
      if(!newVal){
        participant.services.sponsoredBy=undefined;
        participant.services.sponsoredDetails = undefined;
      }
    }
  },
  computed: {
    filteredParticipationType : function(){
      let result = [];
      for (const pt of this.participationTypes) {
        if(pt.conditionScript) {
          let satisfied = matchParticipantCondition(this.participant,pt.conditionScript );
          if(satisfied && pt.exclusive){
            result = [pt];
            break;
          }
        }else{
          result.push(pt);
        }
      }
      return result;
    },
    requiredServicesPrice: function () {
      let totalPrice = 0;
      this.requiredServices.forEach((service) => {
        totalPrice = totalPrice + service.price;
      });
      return totalPrice;
    },
    optionalServicesPrice: function () {
      let totalPrice = 0;
      this.optionalServices.forEach((service) => {
        if (
          this.participant.services.selectedServices.findIndex( s=> s.serviceId == service.id) > -1
        ) {
          totalPrice = totalPrice + service.price;
        }
      });
      return totalPrice;
    },
    totalPriceServices: function () {
      let totalPrice = 0;
      if (this.eventTax) {
        totalPrice = totalPrice + this.eventParticipationTaxAmount;
      }
      totalPrice = totalPrice + this.requiredServicesPrice;
      totalPrice = totalPrice + this.optionalServicesPrice;

      return totalPrice;
    },
    eventParticipationTax: function () {
      const triggerVal = this.eventParticipationTaxTrigger;
      console.log("triggerVal",triggerVal);
      if (
        this.eventTax &&
        this.eventTax.taxAmounts &&
        this.participant.services.participationType
      ) {
        if (this.eventTax.taxAmounts && this.eventTax.taxAmounts.length > 0) {
          const tax = this.eventTax.taxAmounts.find(
            (element) =>
              element.attendanceType.id ==
              this.participant.services.participationType
          );
          return tax;
        }
      }
      return undefined;
    },
    eventParticipationTaxAmount: function () {
      const tax = this.eventParticipationTax;
      if (tax) {
        return tax.amount;
      }
      return 0;
    },
    taxPayed : function(){
      return isTaxPayed(this.participant);
    },
    taxPending : function(){
      const taxPayment = getTaxPayment(this.participant,true);
      if(taxPayment){
        return isPaymentPending(taxPayment);
      }
      return false;
    },
  },
  methods: {
    hasServiceIntervalIntersectionMessage(item){
      if(!item.startDate || !item.endDate){
        return false;
      }
      // Convert the received item's startDate and endDate to Date objects
      var itemStartDate = new Date(item.startDate);
      var itemEndDate = new Date(item.endDate);

      // Loop through each service in the array that were selected
      for (var i = 0; i < this.optionalServices.length; i++) {
        var service = this.optionalServices[i];
        //skip same item and service not selected
        if(item.id == service.id ||  !this.isServiceSelected(service.id)){
          continue;
        }
        if (service.startDate && service.endDate) {
          // Convert the service's startDate and endDate to Date objects
          var serviceStartDate = new Date(service.startDate);
          var serviceEndDate = new Date(service.endDate);

          // Check for overlapping intervals
          if (
            (itemStartDate < serviceEndDate && itemEndDate > serviceStartDate) ||
            (serviceStartDate < itemEndDate && serviceEndDate > itemStartDate)
          ) {
            // Check if the difference between start and end dates is within an hour
            var timeDiff = Math.abs(itemStartDate - serviceEndDate) / 36e5;
            if (timeDiff > 1) {
              return this.$t("cantSelectBecauseInterval",{serviceName : service.name}); // Overlapping interval found
            }
          }
        }
      }
      return false; // No overlapping intervals found
    },
    serviceSponsoredClick(service) {
      const serviceL = this.getParticipantSelectedService(service.id);
      if(serviceL && !serviceL.sponsored){
        serviceL.sponsoredBy = undefined;
        serviceL.sponsoredDetails = undefined;
      }
    },
    handleParticipationTypeChange(value) {
      // check if there new selected value hides hotels 
      let updateProperty = true;
      const attendanceType = this.participationTypes.find(x=>x.id == value);
      if(attendanceType){
        if(attendanceType.hideHotels){
          //check if there are any hotel selection made 
          if(this.participant.rooms && this.participant.rooms.selectedRooms && this.participant.rooms.selectedRooms.length > 0){
            //check if there are any payments for the rooms - if there are , alert that the selection can not be changed 
            let hasPayments = false;
            if(!hasPayments){
              const confirmText = this.$t('confirmAttendanceChangeRooms');
              if (!window.confirm(confirmText)) {
                updateProperty = false;
              }else{
                this.participant.rooms = {roomNote : "",
            roomSponsor : "",
            selectedRooms : []};
              }
            }else{
              const alertText = this.$t('alertAttendanceChangeRooms');
              window.alert(alertText);
              updateProperty = false;
            }
          }
        }
      }
      if(updateProperty){
        Vue.set(this.participant.services, "participationType", value);
      }
      this.eventParticipationTaxTrigger = this.eventParticipationTaxTrigger + 1;
    },
    translateOption(item) {
      return this.$t(`${item.name}`);
    },
    required: function (value) {
      if (value) {
        return true;
      } else {
        return this.$t("error.required");
      }
    },
    validate: function () {
      this.$refs.form.validate();
    },
    isServiceSelected: function (serviceId) {
      return this.participant.services.selectedServices.findIndex( s=> s.serviceId == serviceId) > -1;
    },
    serviceSelected: function (serviceId) {
      const index =
        this.participant.services.selectedServices.findIndex( s=> s.serviceId == serviceId);
      if (index > -1) {
        this.participant.services.selectedServices.splice(index, 1);
      } else {
        this.participant.services.selectedServices.push({serviceId:serviceId});
      }
    },
    getParticipantSelectedService(serviceId) {
      const service = this.participant.services.selectedServices.find( s=> s.serviceId == serviceId);
      return service;
    },
    servicePayed : function(serviceId) {
      return getServicePayment(this.participant, serviceId, true)!=undefined;
    },
    servicePayAccepted : function(serviceId) {
      return isServicePayed(this.participant,serviceId);
    },
    servicePrice : function (service){
      return service.price;
    }
  },
  mounted() { 
    const types = this.filteredParticipationType;
    if(types.length==1){
      this.handleParticipationTypeChange(types[0].id);
    }
  },
  created() { },
};
</script>
<style scoped lang="css">
.text-align-center {
  text-align: center;
}
.manadoryServicePayed {
  opacity: 0.46;
  background-color: rgb(33, 33, 33);
  border-color: rgb(33, 33, 33);
}
</style>